import { Box, Container } from "@material-ui/core";
import { RouteProps, useParams } from "react-router";
import { MyFooter } from "../footer/MyFooter";
import { MyAppBar } from "../appbar/MyAppBar";

import { useAppSelector } from "../../app/hooks";
import { QuestionPage } from "./QuestionPage";
import { generatePath, Redirect } from "react-router-dom";
import { appPath, paramName } from "../../router/AppRoute";

export function InputAnswer(props: RouteProps) {

  const { pageIndexStr } = useParams<{ pageIndexStr: string }>();
  let pageIndex = parseInt(pageIndexStr, 10);

  const questionPages = useAppSelector(state => {
    return state.inputAnswer.session.cxHttpRes!.data!.cxShopToken!.branch!.cxBrand!.cxQuestionHeaders[0]!.cxQuestionPages;
  });

  const prevPageAnswered = useAppSelector(state => {

    if (isNaN(pageIndex)) {
      return false;
    }

    const cxAnswerPages = state.inputAnswer.answer.cxAnswerPageDtos;
    const prevPageIndex = pageIndex - 1;

    if (prevPageIndex < 0 || prevPageIndex >= cxAnswerPages.length) {
      return false;
    }

    return cxAnswerPages[prevPageIndex].answered;
  });

  // 不正なURLは救済しない
  if (isNaN(pageIndex) || pageIndex < 0) {
    return <></>;
  }

  // 不正なページIDは救済しない
  if (pageIndex >= questionPages.length) {
    pageIndex = 1;
  }

  // 直前のページが回答済みかチェック
  if (pageIndex > 0) {

    // 回答済みでない場合、直前のページにリダイレクトさせる
    if (!prevPageAnswered) {

      const pathInputPrev = generatePath(
        appPath.shopqr.inputAnswer,
        {
          [paramName.surveyQestionPageIndexStr]: pageIndex - 1,
        }
      )
      return <Redirect to={pathInputPrev} />
    }
  }

  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <MyAppBar />
      <Box mb={4} style={{ flexGrow: 1 }}>
        <QuestionPage pageIndex={pageIndex} />
      </Box>
      <MyFooter />
    </Container>
  );
}
